<template>
  <vue-draggable
      v-model="internalModel"
      v-bind="$attrs"
      @start="onStart"
      @end="onEnd"
      @update="onUpdate"
      @filter="onFilter"
  >
    <slot />
  </vue-draggable>
</template>

<script setup>
import { computed } from 'vue';
import { VueDraggable } from 'vue-draggable-plus';

defineOptions({ inheritAttrs: false });

const modelValue = defineModel();

const emit = defineEmits(['update:modelValue', 'start', 'end', 'update', 'filter']);

const internalModel = computed({
  get: () => modelValue.value,
  set: (val) => emit('update:modelValue', val)
});

const onStart = (e) => emit('start', e);
const onEnd = (e) => emit('end', e);
const onUpdate = (e) => emit('update', e);
const onFilter = (e) => emit('filter', e);
</script>
